export default "__VITE_ASSET__DwiEMu4g__"